import Cookies from 'js-cookie';

import { isBrowserFn } from '~/utils/browser';

function isWebView() {
  if (!isBrowserFn()) return false;

  return (
    Boolean(window.location.search.match(/[&?]webView=true/i)) || Cookies.get('webView') === 'true'
  );
}

// Server-side counterpart for getServerSideProps: mirrors isWebView() against the request so the
// first server render already reflects the webview and chrome never flashes in. The apps append
// ?webView=true on the first load; the persisted cookie carries it on later loads.
export function isWebViewFromRequest(
  req: { cookies?: Partial<Record<string, string>> },
  resolvedUrl: string
): boolean {
  return req.cookies?.webView?.toLowerCase() === 'true' || /[&?]webView=true/i.test(resolvedUrl);
}

export default isWebView;
